import { Component, HostBinding, Input, OnInit } from '@angular/core';
import { ApiOffer, ApiOfferSet } from '@tytapp/api';

@Component({
  selector: 'tyt-offers-wizard',
  templateUrl: './offers-wizard.component.html',
  styleUrls: ['./offers-wizard.component.scss']
})
export class OffersWizardComponent implements OnInit {

  @Input()
  offerSet: ApiOfferSet;

  @Input()
  showAttentionBanner : boolean = true;

  private _step : string;

  @Input()
  get step() : string {
    return this._step;
  }

  set step(value) {
    this._step = value;
    setTimeout(() => this.showGoBackOption = Object.keys(this.steps).indexOf(this.step) > 0);
  }

  @Input()
  offerUUID : string;

  @Input()
  price : number;

  @Input()
  previewing : boolean;

  @Input()
  period : string;

  @Input()
  offer : ApiOffer;

  @Input()
  inSettings : boolean;

  @Input()
  knownEmail: string;

  @Input()
  knownFirstName: string;

  @Input()
  showNoThanks: boolean = false;

  @HostBinding('class.donation-mode')
  get isDonationMode() {
    if (this.offer)
      return this.offer.period === 'one_time';
    if (this.period)
      return this.period === 'one_time';
  }

  steps = {
    pricing: { title: '1. CHOOSE' },
    signup: { title: '2. REGISTER' },
    payment: { title: '3. PAY' }
  };

  showGoBackOption = false;

  signupStepMode = 'signup';

  objectKeys = Object.keys;

  actBlueLink: string | null;

  constructor() { }

  ngOnInit() {
    if(this.inSettings) {
      delete this.steps.signup;
      this.steps.payment.title = '2. PAY';
    }
    this.actBlueLink = this.offerSet?.actblue_url ?? null;
  }

  get attentionBanner() {
    if (!this.offerSet)
      return '';

    if (this.step === 'pricing')
      return this.offerSet.membership_value_prop_title;
    else if (this.step === 'signup')
      return this.offerSet.profile_prompt_title;
    else if (this.step === 'payment')
      return this.offerSet.payment_prompt_title;
    else
      return this.offerSet.membership_value_prop_title;
  }

  goBack() {
    window.history.back();
  }


  onPricingStepChangedPeriod(period: string) {
    if (this.step !== 'pricing') {
      console.error(`ERROR: Pricing step tried to change active period when active step is ${this.step}`);
      return;
    }
    this.period = period;
  }
}
